import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { DockLog } from '../models';
import { IODataResult } from '@ups/xplat/api/dto';
import { CreateDockLog, MaterialWarehouseDto, SublocationDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DockLogService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/dockLog',
      httpClient,
      httpFactory
    );
  }

  getDockLogs(
    facilityKeyId: number,
    oDataQuery: string
  ): Observable<IODataResult<DockLog>> {
    oDataQuery += '&$format=json&$count=true';

    return this.httpClient.get<IODataResult<DockLog>>(
      `${this.route}/${facilityKeyId}?${oDataQuery.replaceAll(' ', '%20')}`
    );
  }

  createDockLog(createDockLog: CreateDockLog) {
    return this.httpClient.post(`${this.route}`, createDockLog);
  }

  updateDockLog(updateDockLog: CreateDockLog) {
    return this.httpClient.put(`${this.route}`, updateDockLog);
  }

  moveToAnotherSublocation(
    subLocationId: string,
    dockLogIds: string[]
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.route}/sublocations/${subLocationId}`,
      dockLogIds
    );
  }

  addWarehouse(warehouseData: MaterialWarehouseDto) {
    return this.httpClient.post('/api/MaterialWarehouse', warehouseData);
  }

  getWarehouse(facilityId: number) {
    return this.httpClient.get<MaterialWarehouseDto[]>(
      `/api/MaterialWarehouse/${facilityId}`
    );
  }

  deactivateShipmentDocumentItem(shipmentDocumentItemId: string) {
    return this.httpClient.delete(
      `${this.route}/DeactivateShipmentDocumentItem/${shipmentDocumentItemId}`
    );
  }

  addSublocation(sublocationData: SublocationDto) {
    return this.httpClient.post<MaterialWarehouseDto[]>(
      `/api/Sublocation`,
      sublocationData
    );
  }
}
